<script>
import VueApexCharts from 'vue3-apexcharts';
import { SEVERITY_LEVELS, SEVERITY_COLORS } from './severity';

export default {
    name: 'TimelineChart',
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        timeline: { type: Array, required: true },
    },
    computed: {
        series() {
            // Least severe first: ApexCharts stacks the first series at the
            // bottom, so debug sits on the baseline and emergency on top.
            return SEVERITY_LEVELS.map((level) => ({
                name: level,
                data: this.timeline.map((bucket) => bucket.counts[level] ?? 0),
            }));
        },
        options() {
            return {
                chart: {
                    id: 'logs-timeline',
                    stacked: true,
                    toolbar: { show: false },
                    animations: { enabled: false },
                },
                colors: SEVERITY_LEVELS.map((level) => SEVERITY_COLORS[level]),
                plotOptions: {
                    bar: { columnWidth: '80%' },
                },
                dataLabels: { enabled: false },
                xaxis: {
                    categories: this.timeline.map((bucket) => bucket.ts_utc),
                    type: 'datetime',
                    labels: { datetimeUTC: true },
                },
                yaxis: {
                    labels: { formatter: (value) => Math.round(value) },
                },
                legend: { position: 'top', horizontalAlign: 'right' },
                tooltip: {
                    x: { format: 'dd MMM HH:mm' },
                },
            };
        },
    },
};
</script>

<template>
    <div class="logs-timeline" style="min-height: 160px">
        <apexchart type="bar" height="160" :options="options" :series="series" />
    </div>
</template>
